import { isValidLocale } from "@instacart/ipp-auth-service-tools"

const LOCALE_STORAGE_KEY = "userLocale"
const URL_PARAM_KEY = "locale"

export const getStoredLocaleWithFallback = (
  defaultLocale: string = "en-US"
) => {
  // First, check URL parameters
  const urlParams = new URLSearchParams(window.location.search)
  const urlLocale = urlParams.get(URL_PARAM_KEY)
  if (urlLocale && isValidLocale(urlLocale)) {
    localStorage.setItem(LOCALE_STORAGE_KEY, urlLocale)
    return urlLocale
  }

  // Second, check localStorage
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored && isValidLocale(stored)) {
      return stored
    }
  } catch (error) {
    console.warn('Failed to access localStorage for user locale:', error)
  }

  // Third, check browser locale
  const browserLocale = navigator.language
  if (browserLocale && isValidLocale(browserLocale)) {
    return browserLocale
  }

  // Finally, return default locale
  return defaultLocale
}
